<template>
  <div>
    <b-checkbox
      class="checkbox-option"
      v-for="option in options"
      :key="option.id"
      v-model="selection"
      @input="$emit('input', selection)"
      :native-value="option.id"
      @click="option.value = !option.value"
      :class="{ active: option.value }"
    >
      {{ $t(option.title) }}
    </b-checkbox>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    options: Array,
    value: Array,
    label: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    selection: []
  }),
  watch: {
    value: function(val) {
      this.selection = val
    }
  },
  mounted() {
    this.selection = this.value
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss">
.checkbox {
  &.checkbox-option {
    margin-left: 0.5em !important;
    margin: 10px;
    padding: 10px 15px;
    border: solid 2px var(--rosa-eco);
    font-size: 1em;
    background: white;
    border-radius: 0;
    transition: 0.3s ease-in-out;
  }
  &.active {
    background: var(--rosa-eco) !important;
    color: white;
  }
}
@media (max-width: 1024px) {
  .checkbox.checkbox-option {
    width: 100%;
  }
}
.b-checkbox .check {
  border-color: var(--rosa-eco) !important;
}

.active.radio:hover,
.active.checkbox:hover {
  color: white;
}
</style>
